import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export interface AppBreadcrumbItem {
	label: string;
	/** Omit on the current page (or any crumb that should not be a link). */
	href?: string;
	icon?: ReactNode;
}

/**
 * Items-based breadcrumb trail composed from the shadcn Breadcrumb
 * primitives. The app shell and the wiki both build their trail as a flat
 * list, so the composition lives here once instead of in each caller.
 */
export function AppBreadcrumb({
	items,
	className,
}: {
	items: AppBreadcrumbItem[];
	className?: string;
}) {
	return (
		<Breadcrumb className={className}>
			<BreadcrumbList>
				{items.map((item, i) => {
					const isLast = i === items.length - 1;
					const key = `${i}-${item.label}`;
					return (
						<BreadcrumbItem key={key}>
							{i > 0 && <BreadcrumbSeparator />}
							{item.icon && <span className="shrink-0">{item.icon}</span>}
							{isLast || !item.href ? (
								<BreadcrumbPage>{item.label}</BreadcrumbPage>
							) : (
								<BreadcrumbLink asChild>
									<Link to={item.href}>{item.label}</Link>
								</BreadcrumbLink>
							)}
						</BreadcrumbItem>
					);
				})}
			</BreadcrumbList>
		</Breadcrumb>
	);
}
